<template>
<div style="text-align:left;">

  <TopNav />
  <div class="column-left">
    <SideNav />
  </div>
  <ModalImg ref="modalimg2" :link_img="showing_img_link"/>
  <ModalResponder :solicitud_="solicitud" :profesionales_="profesionales" ref="modalresponder" />
  <ModalAgregarComentario :solicitud_="solicitud" :profesionales_="profesionales" ref="modalagregarcomentario" />
  <ModalComentarios :solicitud_="solicitud" :profesionales_="profesionales" ref="modalcomentarios" />

  <div
    v-if="editSolicitudModalVisible"
    class="edit-solicitud-backdrop no-ver"
    @click.self="cerrarModalEditarSolicitud"
  >
    <div class="edit-solicitud-dialog no-ver">
      <div class="edit-solicitud-header">
        <div>
          <div class="edit-solicitud-kicker">Solicitud #{{ editSolicitud ? editSolicitud.id : '' }}</div>
          <h2>Editar solicitud</h2>
        </div>
        <button type="button" class="edit-solicitud-close" @click="cerrarModalEditarSolicitud">
          <b-icon icon="x"></b-icon>
        </button>
      </div>

      <form v-if="editSolicitud" class="edit-solicitud-form" @submit.prevent="guardarSolicitudEditada">
        <div class="edit-solicitud-body">
          <section
            v-for="section in editSolicitudSections"
            :key="'edit-section-' + section.title"
            class="edit-solicitud-section"
          >
            <h3>{{ section.title }}</h3>
            <div class="edit-solicitud-grid">
              <div
                v-for="field in section.fields"
                :key="'edit-field-' + field.key"
                :class="['edit-field', { 'edit-field--wide': field.wide, 'edit-field--checkbox': field.type === 'checkbox' }]"
              >
                <label v-if="field.type !== 'checkbox'" :for="'edit-solicitud-' + field.key">
                  {{ field.label }}
                </label>

                <textarea
                  v-if="field.type === 'textarea'"
                  :id="'edit-solicitud-' + field.key"
                  v-model="editSolicitud[field.key]"
                  :rows="field.rows || 4"
                  :maxlength="field.maxlength"
                ></textarea>

                <select
                  v-else-if="field.type === 'select'"
                  :id="'edit-solicitud-' + field.key"
                  v-model="editSolicitud[field.key]"
                >
                  <option v-if="field.allowEmpty" value="">Sin definir</option>
                  <option
                    v-for="option in field.options"
                    :key="'edit-option-' + field.key + '-' + option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>

                <select
                  v-else-if="field.type === 'nullableBool'"
                  :id="'edit-solicitud-' + field.key"
                  v-model="editSolicitud[field.key]"
                >
                  <option :value="null">Sin definir</option>
                  <option :value="true">Si</option>
                  <option :value="false">No</option>
                </select>

                <label v-else-if="field.type === 'checkbox'" class="edit-checkbox">
                  <input type="checkbox" v-model="editSolicitud[field.key]">
                  <span>{{ field.label }}</span>
                </label>

                <input
                  v-else
                  :id="'edit-solicitud-' + field.key"
                  v-model="editSolicitud[field.key]"
                  :type="field.type || 'text'"
                  :step="field.step"
                  :maxlength="field.maxlength"
                  :readonly="field.readonly"
                >
              </div>
            </div>
          </section>

          <section class="edit-solicitud-section">
            <h3>JSON</h3>
            <div class="edit-solicitud-grid">
              <div class="edit-field edit-field--wide">
                <label for="edit-solicitud-atributos">Atributos</label>
                <textarea id="edit-solicitud-atributos" v-model="editAtributosJson" rows="8"></textarea>
              </div>
              <div class="edit-field edit-field--wide">
                <label for="edit-solicitud-lead-snapshot">Lead partner snapshot</label>
                <textarea id="edit-solicitud-lead-snapshot" v-model="editLeadPartnerSnapshotJson" rows="8"></textarea>
              </div>
            </div>
          </section>
        </div>

        <div class="edit-solicitud-footer">
          <button type="button" class="edit-solicitud-secondary" @click="cerrarModalEditarSolicitud">
            Cancelar
          </button>
          <button type="submit" :disabled="editSolicitudSaving">
            {{ editSolicitudSaving ? 'Guardando...' : 'Guardar cambios' }}
          </button>
        </div>
      </form>
    </div>
  </div>


  <div class="column-right">
    <div v-if="admin_datos.superadmin" class="main-container">       
      <div v-if="loaded" class="articulo-principal">
        

        <!--HOVER PRESUPUESTOS-->
        <div style="position: fixed; background-color: white; border-radius: 4px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 10px; max-width: 600px;" :style="{top: mouseY+5+'px', left: mouseX-100+'px'}" v-if="hovering == 'presupuesto' && viendo_presupuesto != null">
          Presupuesto por
<b>


 {{profesionales.find(p=>{ return p.id == viendo_presupuesto.profesional_id}).nombre}}
                  {{profesionales.find(p=>{ return p.id == viendo_presupuesto.profesional_id}).apellido}}
</b>, creado el <b>{{new Date(viendo_presupuesto.fecha_creado).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' })}}</b> y enviado el 
          <b>{{new Date(viendo_presupuesto.fecha_enviado).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' })}}</b>, con los items:
          <br/>
          <br/>
          <div v-for="d in viendo_presupuesto.desgloce.items">{{ d.nombre }} por <b>${{Intl.NumberFormat('de-DE').format(d.precio) }}</b></div>
          <br/>
    
          En estado <b>{{ viendo_presupuesto.estado == 2 ? 'Aprobado' : viendo_presupuesto.estado == 10 ? 'Rechazado' : 'Enviado' }}</b>
        </div>

        <div @mouseleave="" style="position: fixed; background-color: white; border-radius: 4px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 10px; max-width: 600px;" :style="{top: mouseY+5+'px', left: mouseX-100+'px'}" v-if="hovering == 'entradas' && viendo_entradas != null">
          <b>Entradas de bot</b>
          <div v-for="e in viendo_entradas">
            <b>{{new Date(e.fecha.replace(" GMT", "")).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric' })}}</b>
            {{profesionales.find(p=>{ return p.id == e.profesional_id}).nombre}}
                  {{profesionales.find(p=>{ return p.id == e.profesional_id}).apellido}} 
              <span v-if="e.should_respond == 0">Decidió no responder más.</span>
              <span v-else >Respondió {{ e.message }}</span>
        
                  
          </div>

        </div>

        <div style="position: fixed; background-color: white; border-radius: 4px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 10px; max-width: 600px;" :style="{top: mouseY+5+'px', left: mouseX-100+'px'}" v-if="hovering == 'orden' && viendo_orden != null">
          Orden de
<b>


 {{profesionales.find(p=>{ return p.id == viendo_orden.profesional_id}).nombre}}
                  {{profesionales.find(p=>{ return p.id == viendo_orden.profesional_id}).apellido}} en {{ viendo_orden.direccion }}
</b>, creado el <b>{{new Date(viendo_orden.fecha_creado.a, viendo_orden.fecha_creado.m, viendo_orden.fecha_creado.d).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' })}}</b> con los items:
        <div style="height: 10px;"></div>
   
          <div :style="{'color': d.pagado_id ? '#3D9970' :'#FF4136'}"  v-for="d in viendo_orden.servicios">{{ d.nombre }} por <b>${{Intl.NumberFormat('de-DE').format(d.precio) }}</b></div>
          <div style="height: 10px;"></div>
          <b>Pagos hechos:</b>
          <div v-if="p.estado == 1" v-for="p in viendo_orden.pagos">
            El {{new Date( p.fecha_pagado.y, p.fecha_pagado.m-1, p.fecha_pagado.d ).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' }) }}
            por $<b>{{ Intl.NumberFormat('de-DE').format(p.monto) }}</b> mediante {{ p.metodo_pago }}.
          </div>
          <div style="height: 10px;"></div>
          En estado <b>{{ estados_orden[viendo_orden.estado] }}</b>
        </div>

        <div class="controls-row">
          <button @click="initialize_()">Actualizar <b-icon style="color:white !important;" icon="recycle"></b-icon></button>
          <input
            class="search-input"
            placeholder="Filtra por profesional, descripción, país, ubicación, etc..."
            v-model="palabra_buscada"
            type="text"
          >
        </div>

        <div class="filters-section">
          <div class="filters-section__header">
            <span class="filters-section__title">Filtros rápidos</span>
            <button v-if="filtrosActivos.length" class="clear-filters" @click="clearFilters">Limpiar</button>
          </div>
          <div class="filters-grid">
            <label
              v-for="f in filtros"
              :key="f.nombre"
              :class="['filter-option', { 'filter-option--active': f.activo }]"
            >
              <input
                type="checkbox"
                :checked="f.activo"
                @change="toggleFilter(f.nombre)"
              >
              <span>{{ f.label }}</span>
            </label>
          </div>
          <div class="class-filter">
            <label class="class-filter__label" for="class-filter-select">Clase</label>
            <select
              id="class-filter-select"
              class="class-filter__select"
              v-model="claseSeleccionada"
            >
              <option value="">Todas</option>
              <option
                v-for="option in claseOptions"
                :key="'clase-' + option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="active-filters" v-if="filtrosActivos.length || claseSeleccionada">
            <span class="active-filters__label">Filtros activos:</span>
            <button
              v-for="f in filtrosActivos"
              :key="'activo-' + f.nombre"
              class="active-filter-chip"
              @click="toggleFilter(f.nombre)"
            >
              {{ f.label }}
              <span class="chip-close">×</span>
            </button>
            <button
              v-if="claseSeleccionada"
              class="active-filter-chip"
              @click="claseSeleccionada = ''"
            >
              Clase: {{ claseSeleccionadaTexto }}
              <span class="chip-close">×</span>
            </button>
          </div>
        </div>
        
        <div style="position:absolute; right:0px; top:0px;"> 
          Desde <input id="x2" type="date" v-model="dt_dia" >
        </div>
        <table class="tablex">
    <thead>
        <tr>
            <th></th>
            <th>Visible</th>
            <th>💬</th>
            <th>🤖</th>
            <th>ID</th>
            <th>País</th>
            <th>Ultimo mensaje</th>
            <th>Estado</th>
            <th>Presupuestos</th>
            <th>Ordenes</th>
            <th>Fecha</th>
            <th>Título</th>
            <th>Descripción</th>
            <th>Ubicación</th>
            <th>Categoría</th>
            <th>Nombre</th>
            <th>Contacto</th>
            <th>Precio</th>
            <th>Compradores</th>
            <th>Fuente</th>
            <th>Acciones</th>

        </tr>
    </thead>
    <tbody>
      <template v-for="s, u in solicitudes_filtradas">
        
        <tr  :style="{'background-color': s.atributos.marcada == 1 ? '#FFDC00': ''}" v-on:click="(event)=> { if(!event.target.classList.contains('no-ver')) s.viendo = !s.viendo; }" >
            <td >
              
              <div v-if="utima_respuesta_cliente(s)" style="background-color: #FF4136; color:white; height: 30px; font-size: 25px; width: 30px; font-weight: 700; display: flex; justify-content: center;  align-items: center;   border-radius: 100%;"><!-- <b-icon icon="exclamation-circle"></b-icon -->!</div>
              
              </td>
              <td>
                <div class="purple-label" v-if="s.profesional_id"> 
                {{profesionales.find(p=>{ return p.id == s.profesional_id}).nombre}}
                {{profesionales.find(p=>{ return p.id == s.profesional_id}).apellido}}
                </div>
                <div class="blue-label" v-else>Publica </div>
              </td>
              <td><div v-on:click="mostrarModalComentariosS(s)" class="n-comentarios no-ver" v-if="s.atributos.comentarios != undefined">{{ s.atributos.comentarios.length }}</div></td>
              
              <td>
             
               
                <div @mouseover="hoverItem($event, 'entradas'); viendo_entradas = s.entradas_autorespuesta;"  @mouseleave="hoverItem($event, '');" class="n-comentarios-bot no-ver" v-if="s.entradas_autorespuesta.length != 0">{{ s.entradas_autorespuesta.length }}</div>
                </td>
      
              <td>
                <router-link
                  class="solicitud-detail-link no-ver"
                  :to="`/SolicitudDetalleAdmin/${s.id}`"
                  @click.native.stop
                >
                  {{ s.id }}
                </router-link>
              </td>
              <td>{{nombrePais(s)}}</td>
              <td>
                <div v-if="s.ultimo_mensaje_fecha">
                  hace {{ ( getDateDifference(new Date(s.ultimo_mensaje_fecha.replace(" GMT", "")), new Date()))}} 
                </div>
                <div style="color:#FF4136; font-weight: 700;" v-else>
                  sin respuestas

                </div>
                </td>
            <td >
              <div style="color:#2ECC40; font-weight: 700;" v-if="s.pagado">Pagado <span :style="{'color': s.monto_pagado == s.monto_agregado ? 'rgba(46, 204, 64, 1)' : '#FFDC00'}">({{s.monto_pagado}} de {{ s.monto_agregado }})</span></div>
              <div style="color:#FFDC00; font-weight: 700;" v-else-if="s.tiene_orden">Orden Enviada</div>
              <div  style="color:#FF4136; font-weight: 700;" v-else>Sin Orden</div>
            </td>
            <td>
              <div v-if="s.tiene_presupuesto ">
                <tempalte v-for="o in s.ordenes">
                 
                  <div @mouseover="hoverItem($event, 'presupuesto'); viendo_presupuesto = pr;"  @mouseleave="hoverItem($event, ''); viendo_presupuesto = null;" style="border-radius: 5px; padding: 0px 2px;  margin-bottom: 10px;":style="{'background-color': pr.estado == 2  ? 'rgba(46, 204, 64, 0.6)' :  pr.estado == 10 ? '#FF4136' : '#FFDC00'}" v-if="pr.estado != 0" v-for="pr in o.presupuestos">
                  <span v-if="profesionales.find(p=>{ return p.id == pr.profesional_id})">
                    {{profesionales.find(p=>{ return p.id == pr.profesional_id}).nombre}}
                  {{profesionales.find(p=>{ return p.id == pr.profesional_id}).apellido}}
                  </span>
                  <span v-else>
                    NO SE ENCONTRÓ PROFESIONAL
                  </span>
                  por ${{Intl.NumberFormat('de-DE').format(pr.monto_total)}} en estado {{ pr.estado == 2 ? 'Aprobado' : pr.estado == 10 ? 'Rechazado' : 'Enviado' }}
                  </div>

                </tempalte>

              </div>
              <!-- {{ s.tiene_presupuesto }} -->
            </td>
            <td>
              <div @mouseover="hoverItem($event, 'orden'); viendo_orden = o;"  @mouseleave="hoverItem($event, ''); viendo_orden = null;" style="border-radius: 5px; padding: 0px 2px; margin-bottom: 10px;" :style="{'background-color': o.estado != 0  ? 'rgba(46, 204, 64, 0.6)' : '#FFDC00'}" v-for="o in s.ordenes">
                Id: <b>{{ o.id }}</b>, de                   {{profesionales.find(p=>{ return p.id == o.profesional_id}).nombre}}
                  {{profesionales.find(p=>{ return p.id == o.profesional_id}).apellido}} en estado <b>{{ estados_orden[o.estado] }}</b>

              </div>
            </td>
            <td >{{formatDateIgnoreTimezone(s.fecha_creado)}}</td>
            <td >{{s.titulo}}</td>
            <td >{{s.descripcion}}</td>
            <td >{{nombreComuna(s)}}</td>
            <td >{{nombreCategoria(s)}}</td>
            <td style="font-weight: 700;" :style="{'color':s.usuario && s.usuario.verificado == 1 ? '#3D9970': '#FF4136'}" >{{s.nombre}}</td>
            <td>
              <div>{{s.telefono}}</div>
              <div>{{s.email}}</div>
            </td>
            <td class="price-cell">{{ formatSolicitudPrecio(s) }}</td>
            <td class="buyers-cell">
              <div v-if="s.compradores_puntos && s.compradores_puntos.length">
                <div
                  class="buyer-chip"
                  v-for="comprador in s.compradores_puntos"
                  :key="s.id + '-comprador-' + comprador.profesional_id"
                >
                  {{ formatSolicitudComprador(comprador) }}
                </div>
              </div>
              <span class="muted-text" v-else>Sin compras</span>
            </td>
            <td>
              <div><b>Clase:</b> {{s.clase || 'sin identificar'}}</div>
              <div><b>Campaña:</b> {{s.utm_campaign}}</div>
              <div><b>Source:</b> {{s.utm_source}}</div>
            </td>
            <td style="text-align: center; position: relative;">
              <button @click.stop="toggleDropdown(s.id)" class="no-ver dots-button">
                &#x22EE; <!-- Vertical ellipsis Unicode character -->
              </button>
              <div v-if="activeDropdownId === s.id" class="actions-dropdown" ref="actionsDropdownRef">
                <div @click.stop="mostrarModal(s); activeDropdownId = null" class="dropdown-item">Responder</div>
                <div @click.stop="mostrarModalEditarSolicitud(s); activeDropdownId = null" class="dropdown-item">Editar solicitud</div>
                <div @click.stop="mostrarModalComentario(s); activeDropdownId = null" class="dropdown-item">Agregar comentario</div>
                <div @click.stop="marcar_solicitud(s.id); activeDropdownId = null" class="dropdown-item">Marcar</div>
                <div @click.stop="marcarComoInactiva(s.id)" class="dropdown-item">Marcar como inactiva</div>
              </div>
            </td>

        </tr>
        <tr  v-if="s.viendo">
            
          <td colspan="21">
            <div>
            <div class="attach-img" v-for="foto in s.fotos.filter(f=>{return f.mensaje_cliente_id == null && f.mensaje_profesional_id == null})" v-on:click="showImg(foto.link)" :style="{'background-image':'url('+foto.link+')'}"   >
                    
                  </div>
            </div>
          <table class="tablex" style="width: 100%;">
            <thead >
              <th></th>
              <th>Fecha</th>
              <th>Autor</th>
              <th>Mensaje</th>
            </thead>
            <tr :style="{'background-color': mensaje.usuario_id != null ? '#a2c2df' : ''}" v-for="mensaje in s.mensajes">
              <td>
              <div style="text-align: center;" v-if="mensaje.usuario_id == null">
                <b-icon v-if="mensaje.estado == 1" style="color: #2ECC40; height: 30px; width: 30px; " icon="check-circle"></b-icon> 
                <b-icon v-else style="color: #AAAAAA; height: 30px; width: 30px;" icon="clock"></b-icon> 
              </div>
              </td>
              <td>{{ new Date(mensaje.fecha.replace(" GMT", "")).toLocaleDateString("es-ES", { year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute:'numeric' }) }}</td>

              <td>{{ mensaje.usuario_id == null ? '(Profesional) '+profesionales.find(p=>{ return p.id == mensaje.profesional_id}).nombre+' '+profesionales.find(p=>{ return p.id == mensaje.profesional_id}).apellido : '(Cliente) '+s.nombre }}
              <div v-if="mensaje.usuario_id != null"> a <b>{{ profesionales.find(p=>{ return p.id == mensaje.profesional_id}).nombre }}</b> 
              

              </div>


              
              </td>
              <td>{{ mensaje.mensaje }} 
<br/>
                <div style="border: 3px solid rgb(255,140,0); margin-top: 10px; background-color: rgba(255,140,0,0.4); padding: 10px; display: inline-block; border-radius: 4px;" v-if="mensaje.atributos.orden != null"> 

                  <b>{{ profesionales.find(p=>{ return p.id == mensaje.profesional_id}).nombre }} </b>
                  envió una solicitud de pago para el cliente por 
                  <b>${{ Intl.NumberFormat('de-DE').format( mensaje.atributos.orden.monto_servicios) }}</b>
                  para el día 
                  <b>{{ new Date(mensaje.atributos.orden.fecha).toLocaleDateString("es-ES", { year: 'numeric', month: 'long', day: 'numeric' }) }}</b>.
                  Los servicios son:
                  <br/>
                  <div style="margin-left: 20px;" v-for="s in mensaje.atributos.orden.servicios" >- {{ s.nombre }} por ${{ Intl.NumberFormat('de-DE').format( s.precio )}}</div>
                </div> 
                <div v-if="s.fotos.find(f=>{return f.mensaje_cliente_id == mensaje.id})">
            <div class="attach-img" v-for="foto in s.fotos.filter(f=>{return f.mensaje_cliente_id == mensaje.id})" v-on:click="showImg(foto.link)" :style="{'background-image':'url('+foto.link+')'}"   >
                    
                  </div>
            </div>
              </td>
            </tr>
          </table>
          </td>
        </tr>

      </template>


    </tbody>
</table>


        
      </div>
      <div v-else class="articulo-principal">
        cargando...

      </div>
    </div>
  </div>


</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import ModalResponder from '@/views/superadmin/ModalResponder.vue';
import ModalAgregarComentario from '@/views/superadmin/ModalAgregarComentario.vue';
import ModalComentarios from '@/views/superadmin/ModalComentarios.vue';
import ModalImg from '@/components/ModalImg.vue';

export default {
  name: 'HelloWorld',
  props: ['id'],
  components: {
    SideNav,
    ModalResponder,
    ModalAgregarComentario,
    ModalComentarios,
    ModalImg,
    TopNav,
  },
  data() {
    return {
      loaded: true,
      solicitudes: [],
      profesionales: [],
      filtros: [
        { nombre: 'pagado', label: 'Pagadas', activo: false },
        { nombre: 'con presupuesto aprobado', label: 'Presupuesto aprobado', activo: false },
        { nombre: 'con presupuesto', label: 'Con presupuesto', activo: false },
        { nombre: 'con orden', label: 'Con orden', activo: false },
        { nombre: 'marcadas', label: 'Marcadas', activo: false },
        { nombre: 'sin respuesta', label: 'Sin respuestas', activo: false },
      ],
      claseOptions: [
        { value: 'chica', label: 'Chica' },
        { value: 'mediana', label: 'Mediana' },
        { value: 'grande', label: 'Grande' },
        { value: 'desconocida', label: 'Desconocida' },
        { value: 'sin_identificar', label: 'Sin identificar' },
      ],
      claseSeleccionada: '',
      viendo_presupuesto: null,
      viendo_orden: null,
      viendo_entradas: null,
      hovering: '',
      palabra_buscada: '',
      estados_orden: {
        0: 'pendiente',
        1: 'agendado',
        2: 'confirmado',
        3: 'en proceso',
        4: 'atendido',
      },
      solicitud: {},
      showing_img_link: '',
      dt_dia: '',
      activeDropdownId: null, // Added for dropdown
      editSolicitudModalVisible: false,
      editSolicitudSaving: false,
      editSolicitud: null,
      editSolicitudTarget: null,
      editAtributosJson: '',
      editLeadPartnerSnapshotJson: '',
    };
  },
  created() {},
  methods: {
    ...mapActions(['initialize']),
    valueOrEmpty(value) {
      return value === null || value === undefined ? '' : value;
    },
    toDatetimeLocal(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      const pad = number => String(number).padStart(2, '0');
      return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
      ].join('-') + 'T' + [pad(date.getHours()), pad(date.getMinutes())].join(':');
    },
    formatJsonForEdit(value) {
      if (value === null || value === undefined || value === '') return '{}';
      if (typeof value === 'string') {
        try {
          return JSON.stringify(JSON.parse(value), null, 2);
        } catch (e) {
          return value;
        }
      }
      return JSON.stringify(value, null, 2);
    },
    parseJsonObjectField(value, label) {
      const raw = (value || '').trim();
      if (!raw) return {};
      let parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        throw new Error(label + ' no tiene un JSON valido.');
      }
      if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') {
        throw new Error(label + ' debe ser un objeto JSON.');
      }
      return parsed;
    },
    buildSolicitudEditForm(solicitud_) {
      const dateValue = (...keys) => {
        for (const key of keys) {
          if (solicitud_[key]) return this.toDatetimeLocal(solicitud_[key]);
        }
        return '';
      };
      return {
        id: solicitud_.id,
        uuid: this.valueOrEmpty(solicitud_.uuid),
        usuario_id: this.valueOrEmpty(solicitud_.usuario_id),
        administrador_propiedad_id: this.valueOrEmpty(solicitud_.administrador_propiedad_id),
        empresa_id: this.valueOrEmpty(solicitud_.empresa_id),
        lead_partner_id: this.valueOrEmpty(solicitud_.lead_partner_id),
        propiedad_configuracion_id: this.valueOrEmpty(solicitud_.propiedad_configuracion_id),
        profesional_id: this.valueOrEmpty(solicitud_.profesional_id),
        original_profesional_id: this.valueOrEmpty(solicitud_.original_profesional_id),
        estado: this.valueOrEmpty(solicitud_.estado),
        fecha_creado: dateValue('fecha_creado_iso', 'fecha_creado'),
        ultimo_recordatorio: dateValue('ultimo_recordatorio_iso', 'ultimo_recordatorio'),
        lead_partner_attributed_at: dateValue('lead_partner_attributed_at'),
        priced_at: dateValue('priced_at'),
        nombre: this.valueOrEmpty(solicitud_.nombre),
        apellido: this.valueOrEmpty(solicitud_.apellido),
        email: this.valueOrEmpty(solicitud_.email),
        telefono: this.valueOrEmpty(solicitud_.telefono),
        direccion: this.valueOrEmpty(solicitud_.direccion),
        tipo_propiedad: this.valueOrEmpty(solicitud_.tipo_propiedad),
        numero_apartamento: this.valueOrEmpty(solicitud_.numero_apartamento),
        descripcion: this.valueOrEmpty(solicitud_.descripcion),
        titulo: this.valueOrEmpty(solicitud_.titulo),
        categoria_id: this.valueOrEmpty(solicitud_.categoria_id),
        comuna_id: this.valueOrEmpty(solicitud_.comuna_id),
        lat: this.valueOrEmpty(solicitud_.lat),
        lng: this.valueOrEmpty(solicitud_.lng),
        place_id: this.valueOrEmpty(solicitud_.place_id),
        clase: this.valueOrEmpty(solicitud_.clase),
        prioridad: this.valueOrEmpty(solicitud_.prioridad),
        visibilidad_profesionales: this.valueOrEmpty(solicitud_.visibilidad_profesionales),
        cumple_politicas: solicitud_.cumple_politicas === null || solicitud_.cumple_politicas === undefined ? null : Boolean(solicitud_.cumple_politicas),
        motivo: this.valueOrEmpty(solicitud_.motivo),
        ip_address: this.valueOrEmpty(solicitud_.ip_address),
        lead_partner_source: this.valueOrEmpty(solicitud_.lead_partner_source),
        notificacion_apertura_enviada: Boolean(solicitud_.notificacion_apertura_enviada),
        permite_presupuesto: Boolean(solicitud_.permite_presupuesto),
        puede_iniciarse_por_profesional: Boolean(solicitud_.puede_iniciarse_por_profesional),
        chat_habilitado: Boolean(solicitud_.chat_habilitado),
        notificar_cliente: Boolean(solicitud_.notificar_cliente),
        notificar_chat: Boolean(solicitud_.notificar_chat),
        notificar_contacto_propiedad: Boolean(solicitud_.notificar_contacto_propiedad),
        requiere_compra_puntos: Boolean(solicitud_.requiere_compra_puntos),
        puntos_jobbing_costo: this.valueOrEmpty(solicitud_.puntos_jobbing_costo),
        precio_lead_clp: this.valueOrEmpty(solicitud_.precio_lead_clp),
        precio_lead_min_clp: this.valueOrEmpty(solicitud_.precio_lead_min_clp),
        precio_lead_max_clp: this.valueOrEmpty(solicitud_.precio_lead_max_clp),
        pricing_confidence: this.valueOrEmpty(solicitud_.pricing_confidence),
        pricing_confidence_score: this.valueOrEmpty(solicitud_.pricing_confidence_score),
        pricing_model_key: this.valueOrEmpty(solicitud_.pricing_model_key),
        pricing_model_version: this.valueOrEmpty(solicitud_.pricing_model_version),
        pricing_status: this.valueOrEmpty(solicitud_.pricing_status),
        pricing_error: this.valueOrEmpty(solicitud_.pricing_error),
        pricing_features_json: this.valueOrEmpty(solicitud_.pricing_features_json),
        utm_source: this.valueOrEmpty(solicitud_.utm_source),
        utm_medium: this.valueOrEmpty(solicitud_.utm_medium),
        utm_campaign: this.valueOrEmpty(solicitud_.utm_campaign),
        utm_term: this.valueOrEmpty(solicitud_.utm_term),
        utm_content: this.valueOrEmpty(solicitud_.utm_content),
      };
    },
    mostrarModalEditarSolicitud(solicitud_) {
      this.editSolicitudTarget = solicitud_;
      this.editSolicitud = this.buildSolicitudEditForm(solicitud_);
      this.editAtributosJson = this.formatJsonForEdit(solicitud_.atributos || {});
      this.editLeadPartnerSnapshotJson = this.formatJsonForEdit(solicitud_.lead_partner_snapshot_json || {});
      this.editSolicitudModalVisible = true;
    },
    cerrarModalEditarSolicitud() {
      if (this.editSolicitudSaving) return;
      this.editSolicitudModalVisible = false;
      this.editSolicitud = null;
      this.editSolicitudTarget = null;
      this.editAtributosJson = '';
      this.editLeadPartnerSnapshotJson = '';
    },
    guardarSolicitudEditada() {
      if (!this.editSolicitud || !this.editSolicitudTarget) return;

      let atributos;
      let leadPartnerSnapshot;
      try {
        atributos = this.parseJsonObjectField(this.editAtributosJson, 'Atributos');
        leadPartnerSnapshot = this.parseJsonObjectField(this.editLeadPartnerSnapshotJson, 'Lead partner snapshot');
      } catch (e) {
        this.$notify({
          group: 'foo',
          title: 'Error',
          text: e.message,
          type: 'error',
        });
        return;
      }

      const payload = {
        ...this.editSolicitud,
        atributos,
        lead_partner_snapshot_json: leadPartnerSnapshot,
      };

      delete payload.id;
      this.editSolicitudSaving = true;
      axios
        .put(window.hostname + 'api/superadmin/solicitudes/' + this.editSolicitudTarget.id, payload)
        .then(response => {
          const solicitudActualizada = response.data && response.data.solicitud ? response.data.solicitud : payload;
          Object.assign(this.editSolicitudTarget, solicitudActualizada);
          if (this.solicitud && this.solicitud.id === this.editSolicitudTarget.id) {
            Object.assign(this.solicitud, solicitudActualizada);
          }
          this.$notify({
            group: 'foo',
            title: 'Exito',
            text: response.data && response.data.message ? response.data.message : 'Solicitud actualizada.',
            type: 'success',
          });
          this.editSolicitudSaving = false;
          this.cerrarModalEditarSolicitud();
          this.$forceUpdate();
        })
        .catch(e => {
          const message = e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'No se pudo actualizar la solicitud.';
          this.$notify({
            group: 'foo',
            title: 'Error',
            text: message,
            type: 'error',
          });
        })
        .finally(() => {
          this.editSolicitudSaving = false;
        });
    },
    formatDateIgnoreTimezone(dateStr) {
    try {
      if (typeof dateStr !== 'string') return 'Fecha inválida';

      const parts = dateStr.split(' ');
      if (parts.length < 4) return 'Fecha inválida';

      const day = parseInt(parts[1]);
      const month = parts[2];
      const year = parts[3];

      const monthNames = {
        Jan: 'enero', Feb: 'febrero', Mar: 'marzo', Apr: 'abril',
        May: 'mayo', Jun: 'junio', Jul: 'julio', Aug: 'agosto',
        Sep: 'septiembre', Oct: 'octubre', Nov: 'noviembre', Dec: 'diciembre'
      };

      if (!monthNames[month] || isNaN(day) || isNaN(parseInt(year))) {
        return 'Fecha inválida';
      }

      return `${day} de ${monthNames[month]} de ${year}`;
    } catch (e) {
      return 'Fecha inválida';
    }
    },
    toggleFilter(nombre) {
      const filtro = this.filtros.find(x => x.nombre === nombre);
      if (filtro) {
        filtro.activo = !filtro.activo;
      }
    },
    clearFilters() {
      this.filtros.forEach(f => {
        f.activo = false;
      });
      this.claseSeleccionada = '';
    },
    createAdjustedDate(hoursOffset) {
      let date = new Date();
      date.setHours(date.getHours() + hoursOffset);
      return date;
    },
    updateMousePosition(event) {
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
    },
    hoverItem(event, hovering) {
      this.hovering = hovering;
    },
    getDateDifference(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const difference = end - start;
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      let result = '';
      if (days > 0) result += `${days} dias, `;
      if (days > 0 || hours > 0) result += `${hours} horas, `;
      result += `${minutes} minutos`;
      return result;
    },
    formatCurrency(value) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) return null;
      return `$${Intl.NumberFormat('de-DE').format(amount)}`;
    },
    formatSolicitudPrecio(solicitud) {
      let precio = null;
      if (solicitud.precio_lead_clp !== null && solicitud.precio_lead_clp !== undefined) {
        precio = solicitud.precio_lead_clp;
      } else if (Number(solicitud.puntos_jobbing_costo) > 0) {
        precio = solicitud.puntos_jobbing_costo;
      }
      return this.formatCurrency(precio) || 'Sin precio';
    },
    formatSolicitudComprador(comprador) {
      const nombre = [comprador.nombre, comprador.apellido].filter(Boolean).join(' ') || 'Profesional';
      const puntos = Number(comprador.puntos_jobbing_gastados) > 0
        ? ` (${Intl.NumberFormat('de-DE').format(comprador.puntos_jobbing_gastados)} pts)`
        : '';
      const fecha = this.formatSolicitudCompraFecha(comprador.fecha_compra_puntos);
      return `${nombre}${puntos}${fecha ? ' - ' + fecha : ''}`;
    },
    formatSolicitudCompraFecha(fecha) {
      if (!fecha) return '';
      const parsed = new Date(fecha);
      if (Number.isNaN(parsed.getTime())) return '';
      return parsed.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    nombrePais(solicitud) {
      const codigo = (solicitud.pais_codigo || '').trim().toUpperCase();
      const paises = { CL: 'Chile', PE: 'Perú', CO: 'Colombia', AR: 'Argentina', MX: 'México' };
      return paises[codigo] || codigo || 'Sin país';
    },
    nombreComuna(solicitud) {
      if (solicitud.ubicacion_nombre) return solicitud.ubicacion_nombre;
      const comuna = (this.comunas || []).find(x => x.id == solicitud.comuna_id);
      return comuna ? (comuna.etiqueta || comuna.Nombre || comuna.nombre || 'Sin ubicación') : 'Sin ubicación';
    },
    nombreCategoria(solicitud) {
      if (solicitud && solicitud.categoria && (solicitud.categoria.nombre || solicitud.categoria.Nombre)) {
        return solicitud.categoria.nombre || solicitud.categoria.Nombre;
      }
      const categoriaId = solicitud ? solicitud.categoria_id : null;
      const categoria = (this.categorias || []).find(x => x.id == categoriaId);
      return categoria ? (categoria.nombre || categoria.Nombre || 'Sin categoría') : 'Sin categoría';
    },
    showImg(link) {
      this.showing_img_link = link;
      this.$refs.modalimg2.show();
    },
    mostrarModal(solicitud_) {
      this.solicitud = solicitud_;
      this.$refs.modalresponder.show();
    },
    mostrarModalComentario(solicitud_) {
      this.solicitud = solicitud_;
      this.$refs.modalagregarcomentario.show();
    },
    mostrarModalComentariosS(solicitud_) {
      this.solicitud = solicitud_;
      this.$refs.modalcomentarios.show();
    },
    utima_respuesta_cliente(solicitud_) {
      let ultimo_mensaje_pro = null;
      if (solicitud_.mensajes_profesional.length > 0) {
        ultimo_mensaje_pro = solicitud_.mensajes_profesional[solicitud_.mensajes_profesional.length - 1];
      }
      let ultimo_mensaje_cliente = null;
      if (solicitud_.mensajes_usuario.length > 0) {
        ultimo_mensaje_cliente = solicitud_.mensajes_usuario[solicitud_.mensajes_usuario.length - 1];
      }
      if (ultimo_mensaje_pro == null && ultimo_mensaje_cliente != null) return true;
      if (ultimo_mensaje_pro != null && ultimo_mensaje_cliente == null) return false;
      if (ultimo_mensaje_cliente == null && ultimo_mensaje_pro == null) return true;
      if (new Date(ultimo_mensaje_pro.fecha) < new Date(ultimo_mensaje_cliente.fecha)) return true;
      return false;
    },
    marcar_solicitud(solicitud_id) {
      let _solicitud = this.solicitudes.find(x => x.id === solicitud_id);
      this.status = -1;

      axios
        .post(window.hostname + 'api/superadmin/solicitud_marcar_pinneada', {
          solicitud_id: _solicitud.id,
        })
        .then(r => {
          this.status = 1;
          this.loading = false;
          this.$notify({
            group: 'foo',
            title: '¡Éxito!',
            text: r.data.menssage,
            type: 'success',
          });
          _solicitud.atributos.marcada = r.data.marca;
          this.$forceUpdate();
        })
        .catch(e => {
          this.$notify({
            group: 'foo',
            title: '¡Error!',
            text: '¡Ha ocurrido un error!',
            type: 'error',
          });

          this.status = 2;
          this.loading = false;
        });
    },
    toggleDropdown(solicitudId) {
      if (this.activeDropdownId === solicitudId) {
        this.activeDropdownId = null;
      } else {
        this.activeDropdownId = solicitudId;
      }
    },
    marcarComoInactiva(solicitudId) {
      if (window.confirm("¿Está seguro de que desea marcar esta solicitud como inactiva?")) {
        // Placeholder for API call
        console.log(`Solicitud ${solicitudId} marcada como inactiva`);
         axios.post(window.hostname + 'api/superadmin/solicitudes/marcar-inactiva', { // Corrected path
          solicitud_id: solicitudId,
        })
        .then(r => {
          this.$notify({
            group: 'foo',
            title: '¡Éxito!',
            text: 'Solicitud marcada como inactiva.', // Or use r.data.message if available
            type: 'success',
          });
          // Optionally, update local data to reflect the change
          const solicitud = this.solicitudes.find(s => s.id === solicitudId);
          if (solicitud) {
            // Add a property to indicate it's inactive, e.g., solicitud.inactiva = true;
            // This depends on how you want to handle it in the UI
          }
          this.activeDropdownId = null; // Close dropdown
        })
        .catch(e => {
          this.$notify({
            group: 'foo',
            title: '¡Error!',
            text: '¡Ha ocurrido un error al marcar como inactiva!',
            type: 'error',
          });
          console.error("Error al marcar como inactiva:", e);
          this.activeDropdownId = null; // Close dropdown
        });
      }
    },
    handleClickOutside(event) {
      if (this.activeDropdownId !== null) {
        const dropdownRef = this.$refs.actionsDropdownRef;

        if (dropdownRef instanceof Node && typeof dropdownRef.contains === 'function') {
          const isClickOnDotsButton = event.target.closest('.dots-button');
          if (!dropdownRef.contains(event.target) && !isClickOnDotsButton) {
            this.activeDropdownId = null;
          }
        } else {
          // Fallback for unexpected ref state:
          // If a dropdown was supposed to be open (activeDropdownId is not null),
          // but the ref is invalid, close it if the click wasn't on a toggle button.
          const isClickOnDotsButton = event.target.closest('.dots-button');
          if (!isClickOnDotsButton) {
            this.activeDropdownId = null;
          }
        }
      }
    },
    initialize_() {
      this.loaded = false;
      axios
        .post(window.hostname + 'api/superadmin/initialize_responder_solicitudes', {
          desde: this.dt_dia,
        })
        .then(response => {
          this.profesionales = response.data.profesionales;
          var insertando;
          this.solicitudes = [];
          var profesionales_ins = [];
          var prof_;
          for (var f of response.data.solicitudes) {
            insertando = f;
            insertando.profesionales = [];
            insertando.tiene_presupuesto = false;
            insertando.tiene_presupuesto_aprobado = false;
            insertando.pagado = false;
            insertando.tiene_orden = false;
            insertando.viendo = false;
            insertando.mensajes = [];
            insertando.monto_pagado = 0;
            insertando.monto_agregado = 0;
            console.log("AAA", insertando);
            for (var o of insertando.ordenes) {
              if (o.presupuestos.length > 0) {
                for (var p of o.presupuestos) {
                  if (p.estado !== 0) {
                    insertando.tiene_presupuesto = true;
                  }
                  if (p.estado === 2) {
                    insertando.tiene_presupuesto_aprobado = true;
                    break;
                  }
                }
                for (var pags of o.pagos) {
                  if (pags.estado === 1) {
                    insertando.monto_pagado += pags.monto;
                  }
                }
                for (var it of o.servicios) {
                  insertando.monto_agregado += it.precio;
                }
                if (insertando.tiene_presupuesto_aprobado) {
                  break;
                }
              }
              console.log("LA ORDEN ES ", o);
            }
            profesionales_ins = [];
            for (var j of insertando.mensajes_profesional) {
              if (typeof j.atributos === 'object') {
                if ('orden' in j.atributos) {
                  insertando.tiene_orden = true;
                  if (j.atributos.orden.pagado === 1) {
                    insertando.pagado = true;
                  }
                  // Agregando al profesional para la busqueda
                  if (!profesionales_ins.includes(j.profesional_id)) {
                    profesionales_ins.push(j.profesional_id);
                    prof_ = this.profesionales.find(x => x.id === j.profesional_id);
                    if (prof_) {
                      insertando.profesionales.push((prof_.nombre + ' ' + prof_.apellido).toLowerCase());
                    }
                  }
                }
              }
              insertando.mensajes.push(j);
            }
            for (var j of insertando.mensajes_usuario) {
              insertando.mensajes.push(j);
            }
            insertando.mensajes.sort((a, b) => {
              return new Date(a.fecha) - new Date(b.fecha);
            });
            if (insertando.mensajes.length > 0) {
              insertando.ultimo_mensaje_fecha = insertando.mensajes[insertando.mensajes.length - 1].fecha;
            }
            this.solicitudes.push(insertando);
          }
          this.solicitudes.sort((a, b) => {
            var dateA = new Date(a.fecha_creado);
            var dateB = new Date(b.fecha_creado);
            if (a.ultimo_mensaje_fecha) dateA = new Date(a.ultimo_mensaje_fecha);
            if (b.ultimo_mensaje_fecha) dateB = new Date(b.ultimo_mensaje_fecha);
            return dateB - dateA; // Descending order
          });
          this.loaded = true;
        })
        .catch(e => {
          this.loaded = true;
          console.log("Error al cargar...", e);
        });
    },
  },
  computed: {
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos']),
    editEstadoOptions() {
      return [
        { value: 0, label: 'Pendiente' },
        { value: 1, label: 'Activa' },
        { value: 2, label: 'Terminada' },
        { value: 10, label: 'Inactiva' },
      ];
    },
    editPrioridadOptions() {
      return [
        { value: 'alta', label: 'Alta' },
        { value: 'media', label: 'Media' },
        { value: 'baja', label: 'Baja' },
        { value: 'desconocida', label: 'Desconocida' },
      ];
    },
    editVisibilidadOptions() {
      return [
        { value: 'my', label: 'Privada/asignada' },
        { value: 'selected', label: 'Seleccionados' },
        { value: 'all', label: 'Publica' },
      ];
    },
    editPricingConfidenceOptions() {
      return [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
      ];
    },
    editPricingStatusOptions() {
      return [
        { value: 'priced', label: 'Priced' },
        { value: 'skipped', label: 'Skipped' },
        { value: 'error', label: 'Error' },
      ];
    },
    editCategoriaOptions() {
      return (this.categorias || []).map(c => ({
        value: c.id,
        label: c.nombre || c.Nombre || ('Categoria #' + c.id),
      }));
    },
    editComunaOptions() {
      return (this.comunas || []).map(c => ({
        value: c.id,
        label: c.Nombre || c.nombre || ('Comuna #' + c.id),
      }));
    },
    editProfesionalOptions() {
      return (this.profesionales || []).map(p => ({
        value: p.id,
        label: [p.nombre, p.apellido].filter(Boolean).join(' ') || ('Profesional #' + p.id),
      }));
    },
    editSolicitudSections() {
      return [
        {
          title: 'Identificacion',
          fields: [
            { key: 'id', label: 'ID', readonly: true },
            { key: 'uuid', label: 'UUID' },
            { key: 'usuario_id', label: 'Usuario ID', type: 'number' },
            { key: 'administrador_propiedad_id', label: 'Admin propiedad ID', type: 'number' },
            { key: 'empresa_id', label: 'Empresa ID', type: 'number' },
            { key: 'lead_partner_id', label: 'Lead partner ID', type: 'number' },
            { key: 'propiedad_configuracion_id', label: 'Propiedad config. ID', type: 'number' },
            { key: 'profesional_id', label: 'Profesional asignado', type: 'select', options: this.editProfesionalOptions, allowEmpty: true },
            { key: 'original_profesional_id', label: 'Profesional original', type: 'select', options: this.editProfesionalOptions, allowEmpty: true },
            { key: 'estado', label: 'Estado', type: 'select', options: this.editEstadoOptions, allowEmpty: true },
            { key: 'fecha_creado', label: 'Fecha creado', type: 'datetime-local' },
          ],
        },
        {
          title: 'Cliente y contacto',
          fields: [
            { key: 'nombre', label: 'Nombre', maxlength: 300 },
            { key: 'apellido', label: 'Apellido', maxlength: 300 },
            { key: 'email', label: 'Email', type: 'email', maxlength: 300 },
            { key: 'telefono', label: 'Telefono', maxlength: 20 },
          ],
        },
        {
          title: 'Servicio y ubicacion',
          fields: [
            { key: 'titulo', label: 'Titulo', maxlength: 100 },
            { key: 'descripcion', label: 'Descripcion', type: 'textarea', rows: 5, maxlength: 2000, wide: true },
            { key: 'categoria_id', label: 'Categoria', type: 'select', options: this.editCategoriaOptions, allowEmpty: true },
            { key: 'comuna_id', label: 'Comuna', type: 'select', options: this.editComunaOptions, allowEmpty: true },
            { key: 'direccion', label: 'Direccion', maxlength: 500, wide: true },
            { key: 'tipo_propiedad', label: 'Tipo propiedad', maxlength: 50 },
            { key: 'numero_apartamento', label: 'Numero apartamento', maxlength: 20 },
            { key: 'lat', label: 'Latitud', type: 'number', step: 'any' },
            { key: 'lng', label: 'Longitud', type: 'number', step: 'any' },
            { key: 'place_id', label: 'Place ID', maxlength: 255, wide: true },
          ],
        },
        {
          title: 'Operacion',
          fields: [
            { key: 'clase', label: 'Clase', type: 'select', options: this.claseOptions, allowEmpty: true },
            { key: 'prioridad', label: 'Prioridad', type: 'select', options: this.editPrioridadOptions, allowEmpty: true },
            { key: 'visibilidad_profesionales', label: 'Visibilidad', type: 'select', options: this.editVisibilidadOptions, allowEmpty: true },
            { key: 'cumple_politicas', label: 'Cumple politicas', type: 'nullableBool' },
            { key: 'motivo', label: 'Motivo', maxlength: 100 },
            { key: 'ip_address', label: 'IP', maxlength: 45 },
            { key: 'ultimo_recordatorio', label: 'Ultimo recordatorio', type: 'datetime-local' },
            { key: 'lead_partner_source', label: 'Lead partner source', maxlength: 40 },
            { key: 'lead_partner_attributed_at', label: 'Lead attributed at', type: 'datetime-local' },
          ],
        },
        {
          title: 'Notificaciones y flags',
          fields: [
            { key: 'notificacion_apertura_enviada', label: 'Notificacion apertura enviada', type: 'checkbox' },
            { key: 'permite_presupuesto', label: 'Permite presupuesto', type: 'checkbox' },
            { key: 'puede_iniciarse_por_profesional', label: 'Puede iniciarse por profesional', type: 'checkbox' },
            { key: 'chat_habilitado', label: 'Chat habilitado', type: 'checkbox' },
            { key: 'notificar_cliente', label: 'Notificar cliente', type: 'checkbox' },
            { key: 'notificar_chat', label: 'Notificar chat', type: 'checkbox' },
            { key: 'notificar_contacto_propiedad', label: 'Notificar contacto propiedad', type: 'checkbox' },
            { key: 'requiere_compra_puntos', label: 'Requiere compra con puntos', type: 'checkbox' },
          ],
        },
        {
          title: 'Pricing',
          fields: [
            { key: 'puntos_jobbing_costo', label: 'Puntos Jobbing costo', type: 'number' },
            { key: 'precio_lead_clp', label: 'Precio lead CLP', type: 'number' },
            { key: 'precio_lead_min_clp', label: 'Precio lead min CLP', type: 'number' },
            { key: 'precio_lead_max_clp', label: 'Precio lead max CLP', type: 'number' },
            { key: 'pricing_confidence', label: 'Pricing confidence', type: 'select', options: this.editPricingConfidenceOptions, allowEmpty: true },
            { key: 'pricing_confidence_score', label: 'Pricing confidence score', type: 'number', step: 'any' },
            { key: 'pricing_status', label: 'Pricing status', type: 'select', options: this.editPricingStatusOptions, allowEmpty: true },
            { key: 'pricing_model_key', label: 'Pricing model key', maxlength: 100 },
            { key: 'pricing_model_version', label: 'Pricing model version', maxlength: 100 },
            { key: 'priced_at', label: 'Priced at', type: 'datetime-local' },
            { key: 'pricing_error', label: 'Pricing error', type: 'textarea', rows: 4, wide: true },
            { key: 'pricing_features_json', label: 'Pricing features JSON', type: 'textarea', rows: 6, wide: true },
          ],
        },
        {
          title: 'UTM',
          fields: [
            { key: 'utm_source', label: 'UTM source', maxlength: 255 },
            { key: 'utm_medium', label: 'UTM medium', maxlength: 255 },
            { key: 'utm_campaign', label: 'UTM campaign', maxlength: 255 },
            { key: 'utm_term', label: 'UTM term', maxlength: 255 },
            { key: 'utm_content', label: 'UTM content', maxlength: 255 },
          ],
        },
      ];
    },
    filtrosActivos() {
      return this.filtros.filter(f => f.activo);
    },
    claseSeleccionadaTexto() {
      const option = this.claseOptions.find(o => o.value === this.claseSeleccionada);
      return option ? option.label : this.claseSeleccionada;
    },
    solicitudes_filtradas() {
      let ret = this.solicitudes;

      // Apply active filters
      if (this.filtros.find(x => x.nombre === 'pagado').activo) {
        ret = ret.filter(x => x.pagado);
      }
      if (this.filtros.find(x => x.nombre === 'con presupuesto aprobado').activo) {
        ret = ret.filter(x => x.tiene_presupuesto_aprobado);
      }
      if (this.filtros.find(x => x.nombre === 'con presupuesto').activo) {
        ret = ret.filter(x => x.tiene_presupuesto);
      }
      if (this.filtros.find(x => x.nombre === 'marcadas').activo) {
        ret = ret.filter(x => x.atributos.marcada);
      }
      if (this.filtros.find(x => x.nombre === 'con orden').activo) {
        ret = ret.filter(x => x.ordenes.some(y => y.estado !== 0));
      }
      if (this.filtros.find(x => x.nombre === 'sin respuesta').activo) {
        ret = ret.filter(x => {
          const mensajesProfesional = Array.isArray(x.mensajes_profesional) ? x.mensajes_profesional.length : 0;
          const mensajesUsuario = Array.isArray(x.mensajes_usuario) ? x.mensajes_usuario.length : 0;
          return mensajesProfesional === 0 && mensajesUsuario === 0;
        });
      }

      if (this.claseSeleccionada) {
        const selectedClass = this.claseSeleccionada.toLowerCase();
        ret = ret.filter(x => {
          const claseNormalizada = (x.clase ? x.clase : 'sin_identificar')
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '_');
          return claseNormalizada === selectedClass;
        });
      }

      // Apply search filter
      if (this.palabra_buscada.trim() !== '') {
        const search = this.palabra_buscada.toLowerCase();

        ret = ret.filter(item => {
          // Check description
          const descripcionMatch = item.descripcion
            ? item.descripcion.toLowerCase().includes(search)
            : false;

          // Check name
          const nombreMatch = item.nombre
            ? item.nombre.toLowerCase().includes(search)
            : false;

          // Check professionals
          const professionalsMatch = item.profesionales.some(prof =>
            prof.toLowerCase().includes(search)
          );

          const buyersMatch = (item.compradores_puntos || []).some(comprador => {
            const nombre = [comprador.nombre, comprador.apellido].filter(Boolean).join(' ').toLowerCase();
            return nombre.includes(search);
          });

          const comunaMatch = this.nombreComuna(item).toLowerCase().includes(search);

          const categoriaMatch = this.nombreCategoria(item).toLowerCase().includes(search);
          const paisMatch = this.nombrePais(item).toLowerCase().includes(search)
            || (item.pais_codigo || '').toLowerCase().includes(search);

          // Check ordenes (orders)
          const ordenMatch = item.ordenes.some(o => {
            const idMatch = o.id
              ? o.id.toString().toLowerCase().includes(search)
              : false;
            const direccionMatch = o.direccion
              ? o.direccion.toLowerCase().includes(search)
              : false;
            return idMatch || direccionMatch;
          });

          return (
            descripcionMatch ||
            nombreMatch ||
            professionalsMatch ||
            buyersMatch ||
            comunaMatch ||
            categoriaMatch ||
            paisMatch ||
            ordenMatch
          );
        });
      }

      return ret;
    }
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.updateMousePosition);
     document.removeEventListener('click', this.handleClickOutside); // Remove click listener
  },
  mounted() {
    window.addEventListener('mousemove', this.updateMousePosition);
     document.addEventListener('click', this.handleClickOutside); // Add click listener
    if (!this.admin_datos.superadmin) {
      this.$router.push('/');
    }
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.dt_dia = sevenDaysAgo.toISOString().split('T')[0];
  },
  watch: {
    dt_dia(val) {
      this.initialize_();
    },
  }
};
</script>


<style scoped>
.solicitud-detail-link {
  color: #2563eb;
  font-weight: 800;
  text-decoration: none;
}

.solicitud-detail-link:hover {
  text-decoration: underline;
}

.blue-label {
  display: inline-block;
  background-color: #007bff; /* Blue color */
  color: #fff; /* White text */
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
}

.blue-label:hover {
  background-color: #0056b3; /* Darker blue on hover */
  cursor: pointer;
}
.purple-label {
  display: inline-block;
  background-color: #6f42c1; /* Purple color */
  color: #fff; /* White text */
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;
}

.purple-label:hover {
  background-color: #59339d; /* Darker purple on hover */
  cursor: pointer;
}


.n-comentarios{
  background-color: rgb(20, 134, 231);
  color: white;
  font-weight: 700;
  border-radius: 10px;
  padding: 3px 10px;
}
.n-comentarios-bot{
  background-color: rgb(120,120,120);
  color: white;
  font-weight: 700;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 14px;
}
.attach-img{
  margin: 4px;
  border-radius: 10px; 
  background-size: cover; 
  border: 3px solid rgb(20, 134, 231); 
  background-position: center; 
  cursor: pointer; 
  height:150px; 
  width: 150px;  
  overflow: hidden; 
  display: inline-block;
}
    .details {
        display: none;
    }
    body {
        font-family: Arial, sans-serif;
    }

    .tablex {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
    }

    .tablex th, .tablex td {
        text-align: left;
        padding: 8px;
        border-bottom: 1px solid #ddd;
 
    }

    .tablex th {
      background-color: rgb(38, 53, 67);
        color: white;
    }

    .price-cell {
      font-weight: 700;
      white-space: nowrap;
    }

    .buyers-cell {
      min-width: 180px;
    }

    .buyer-chip {
      display: block;
      margin-bottom: 4px;
      color: #0f5132;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.25;
    }

    .muted-text {
      color: #6c757d;
      font-size: 12px;
    }

    .tablex tr:nth-child(even) {
        background-color: #f2f2f2;
    }



    button {
        background-color: #4CAF50;
        color: white;
        padding: 6px 12px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
    }

    button:hover {
        background-color: #45a049;
    }

    
    
td{
  text-align: left;
  cursor: pointer;
}
.articulo-principal{
  position: relative;



}
table
{ 
    margin-left: auto;
    margin-right: auto;
}
.column-right{
  background-color: rgb(242, 247, 251);
  padding-top:80px;
  padding-left:260px;
  width:100%;

}
.main-container{
  background-color: white;

  margin-top:10px;
  padding:20px 20px 10px 20px;
}
@media (max-width: 800px) {
 .column-right{

  padding-left:0px;


}
}

.dots-button {
  background: none;
  border: none;
  font-size: 24px; /* Adjust size as needed */
  cursor: pointer;
  padding: 0 5px;
  color: #333; /* Adjust color as needed */
}

.dots-button:hover {
  background-color: #f0f0f0; /* Light background on hover */
  border-radius: 4px;
}

.actions-dropdown {
  position: absolute;
  right: 30px; /* Adjust to position correctly next to the button */
  top: 0; /* Align with the top of the cell, or adjust as needed */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 100;
  min-width: 180px; /* Adjust as needed */
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.edit-solicitud-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
}

.edit-solicitud-dialog {
  width: min(1180px, 100%);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.35);
  overflow: hidden;
}

.edit-solicitud-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.edit-solicitud-header h2 {
  margin: 0;
  color: #111827;
  font-size: 22px;
  line-height: 1.2;
}

.edit-solicitud-kicker {
  margin-bottom: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.edit-solicitud-close {
  width: 36px;
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e5e7eb;
  color: #111827;
}

.edit-solicitud-close:hover {
  background: #d1d5db;
}

.edit-solicitud-form {
  min-height: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.edit-solicitud-body {
  min-height: 0;
  overflow: auto;
  padding: 18px 22px;
}

.edit-solicitud-section {
  padding: 16px 0 18px;
  border-bottom: 1px solid #e5e7eb;
}

.edit-solicitud-section:first-child {
  padding-top: 0;
}

.edit-solicitud-section:last-child {
  border-bottom: none;
}

.edit-solicitud-section h3 {
  margin: 0 0 14px;
  color: #1f2937;
  font-size: 15px;
  font-weight: 800;
}

.edit-solicitud-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 14px;
}

.edit-field {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edit-field--wide {
  grid-column: 1 / -1;
}

.edit-field--checkbox {
  justify-content: flex-end;
}

.edit-field label {
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.edit-field input,
.edit-field select,
.edit-field textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #fff;
  color: #111827;
  font-size: 14px;
  line-height: 1.35;
  padding: 8px 10px;
  outline: none;
}

.edit-field textarea {
  resize: vertical;
  min-height: 90px;
  font-family: Arial, sans-serif;
}

.edit-field input:focus,
.edit-field select:focus,
.edit-field textarea:focus {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.12);
}

.edit-field input[readonly] {
  background: #f1f5f9;
  color: #64748b;
}

.edit-checkbox {
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #d1d9e6;
  border-radius: 6px;
  background: #f8fafc;
  cursor: pointer;
}

.edit-checkbox input {
  width: 16px;
  min-width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  accent-color: #1d4ed8;
}

.edit-checkbox span {
  color: #334155;
  font-size: 13px;
  font-weight: 800;
}

.edit-solicitud-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.edit-solicitud-footer button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.edit-solicitud-secondary {
  background: #64748b;
}

.edit-solicitud-secondary:hover {
  background: #475569;
}

.controls-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 20px 0 10px;
}

.controls-row .search-input {
  flex: 1 1 280px;
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  font-size: 14px;
  max-width: 420px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.class-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.class-filter__label {
  font-weight: 600;
  color: #263543;
}

.class-filter__select {
  padding: 6px 10px;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background-color: #fff;
  font-size: 14px;
  color: #263543;
  min-width: 160px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.class-filter__select:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.15);
}

.search-input:focus {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 2px rgba(29, 78, 216, 0.15);
}

.filters-section {
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background-color: #f8fafc;
  padding: 16px;
}

.filters-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.filters-section__title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.clear-filters {
  background: none;
  border: none;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
}

.clear-filters:hover {
  text-decoration: underline;
}

.filters-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #d1d9e6;
  border-radius: 999px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: 13px;
}

.filter-option input {
  margin: 0;
  width: 16px;
  height: 16px;
  accent-color: #1d4ed8;
}

.filter-option--active {
  border-color: #1d4ed8;
  background-color: rgba(29, 78, 216, 0.12);
}

.filter-option--active span {
  color: #1d4ed8;
  font-weight: 600;
}

.active-filters {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.active-filters__label {
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
}

.active-filter-chip {
  background-color: #1d4ed8;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.active-filter-chip:hover {
  background-color: #163fa0;
}

.chip-close {
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
}

@media (max-width: 768px) {
  .edit-solicitud-backdrop {
    align-items: stretch;
    padding: 10px;
  }

  .edit-solicitud-dialog {
    max-height: 100%;
  }

  .edit-solicitud-grid {
    grid-template-columns: 1fr;
  }

  .edit-solicitud-footer {
    flex-direction: column-reverse;
  }

  .edit-solicitud-footer button {
    width: 100%;
  }

  .filters-section {
    padding: 12px;
  }

  .filter-option {
    width: 100%;
    justify-content: space-between;
  }

  .controls-row {
    flex-direction: column;
    align-items: stretch;
  }

  .controls-row .search-input {
    flex: 1 1 auto;
    max-width: 100%;
  }
}
</style>

